<template>
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 7.42857V17.2857M20.0255 8.92012C22.4847 10.3214 24.1429 12.9671 24.1429 16C24.1429 20.4972 20.4972 24.1429 16 24.1429C11.5028 24.1429 7.85714 20.4972 7.85714 16C7.85714 12.9671 9.5153 10.3214 11.9745 8.92012M16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1Z" stroke="#130F26" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>

<script>
    export default {
        name: "SwitchIcon"
    }
</script>

<style scoped>

</style>